import React from "react";

import styles from "../assets/styles/FinlandMainCol.module.scss";

const FinlandMainCol = ({ children }) => {
	return (
		<div className={styles.root}>
			<div className={styles.container}>{children}</div>
		</div>
	);
};

export default FinlandMainCol;
